module.exports = __webpack_public_path__ + "c94c96aa5f44699821345ca2d4bb0122.svg";